import React, { ComponentType } from 'react';
import { Container } from '@uds/grid';
import { useTheme } from '@uds/theme-utils';
import { CTA } from 'core/ribbons/cta';
import { ImagesWithAspectRatios } from 'core/ribbons/primitives';
import { RibbonProps, Type } from 'domain/constants/ribbons';
import visibilitySet from 'presentation/hocs/visibilitySet';
import errorBoundary from 'presentation/hocs/errorBoundary';
import Ribbon from 'components/ribbons/Ribbon';
import { ShortcodeProps } from 'presentation/components/Shortcode';

import Pillar from './Pillar';
import useStylesheet from './PillarsRecumbent.stylesheet';

type PillarProps = {
  illustration?: string;
  imageUrl?: string;
  preserveDimension?: string;
  imagesWithAspectRatios?: ImagesWithAspectRatios;
  title?: ShortcodeProps;
  body?: ShortcodeProps;
  ctas?: Array<CTA>;
};

interface OuterProps extends RibbonProps {
  pillars: Array<PillarProps>;
}

declare const i: number;
declare const pillar: PillarProps;

export const PurePillarsRecumbent = ({ id, hBaseline = 3, layout, pillars, colorway, loading, name }: OuterProps) => {
  const { theme } = useTheme();
  const { styles } = useStylesheet({ theme });
  return (
    <Ribbon name={name} colorway={colorway} layout={layout} loading={loading} id={id} type={Type.PILLARS_RECUMBENT}>
      <Container>
        <div style={styles.grid}>
          <For each="pillar" of={pillars} index="i">
            <Pillar key={i} hBaseline={hBaseline} colorway={colorway} ribbonId={id} {...pillar} />
          </For>
        </div>
      </Container>
    </Ribbon>
  );
};

PurePillarsRecumbent.displayName = 'PillarsRecumbent';

export default visibilitySet(errorBoundary(PurePillarsRecumbent)) as ComponentType<OuterProps>;
